module.exports = __webpack_public_path__ + "img/dab_opal.67d4cfa3.jpg";